<template>
  <div class="oido-searchbar">
    <span class="oido-searchbar-icon" v-html="searchIcon"></span>
    <input
      type="text"
      class="oido-searchbar-input"
      :placeholder="placeholder"
      :value="modelValue"
      @input="onInput"
    />
    <span v-if="modelValue" class="oido-searchbar-clear" @click="$emit('update:modelValue', '')">&#215;</span>
  </div>
</template>

<script>
import icons from './icons';

let debounceTimer = null;

export default {
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    debounce: {
      type: [Number, String],
      default: 0
    }
  },
  emits: ['update:modelValue'],
  computed: {
    searchIcon() {
      return icons['search'] || '';
    }
  },
  methods: {
    onInput(e) {
      let value = e.target.value;
      let delay = parseInt(this.debounce) || 0;
      if (delay > 0) {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
          this.$emit('update:modelValue', value);
        }, delay);
      } else {
        this.$emit('update:modelValue', value);
      }
    }
  }
}
</script>

<style scoped>
.oido-searchbar {
  display: flex;
  align-items: center;
  background: #f4f4f4;
  border-radius: 8px;
  padding: 0.35rem 0.6rem;
  gap: 0.4rem;
}

.oido-searchbar-icon {
  width: 1rem;
  height: 1rem;
  flex-shrink: 0;
  opacity: 0.4;
}

.oido-searchbar-input {
  border: none;
  background: none;
  outline: none;
  font-size: 0.85rem;
  width: 100%;
  color: inherit;
  text-align: left;
}

.oido-searchbar-input::placeholder {
  color: #999;
}

.oido-searchbar-clear {
  cursor: pointer;
  font-size: 1.1rem;
  line-height: 1;
  opacity: 0.4;
  flex-shrink: 0;
}

.oido-searchbar-clear:hover {
  opacity: 0.8;
}
</style>

<style>
.oido-searchbar-icon svg {
  width: 100%;
  height: 100%;
  stroke: currentColor;
  fill: none;
  stroke-width: 40px;
}
</style>
